import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import Ajax from "../../lib/ajax";
import PageResult from "@/store/entities/page-result";
import appconst from "./../../lib/appconst";

interface CollectionCodeState extends ListState<any> {
  statuses: Array<any>;
  types: Array<any>;
}
class CollectionCodeModule extends ListModule<CollectionCodeState, any, any> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<any>(),
    loading: false,
    statuses: new Array<any>(),
    types: new Array<any>(),
  };
  actions = {
    async getAll(
      context: ActionContext<CollectionCodeState, any>,
      payload: any
    ) {
      context.state.loading = true;
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/CollectionCode", {
        params: payload.data,
      });
      context.state.loading = false;
      const page = result as PageResult<any>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },

    async get(context: ActionContext<CollectionCodeState, any>, payload: any) {
      let reponse = await Ajax.get(
        "/api/services/app/CollectionCode/GetDetail?Id=" + payload.data.id
      );
      return reponse.data.result;
    },
    async getInfo(
      context: ActionContext<CollectionCodeState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/CollectionCode/info/" + payload.data.code
      );
      return reponse.data.result;
    },
    async create(
      context: ActionContext<CollectionCodeState, any>,
      payload: any
    ) {
      await Ajax.post("/api/services/app/CollectionCode", payload.data);
    },
    async getStatusesForSelect(
      context: ActionContext<CollectionCodeState, any>,
      payload: any
    ) {
      const {
        data: { result },
      } = await Ajax.get(
        "/api/services/app/CollectionCode/GetStatusesForSelect",
        { params: payload.data }
      );
      context.state.statuses = result;
    },
    async getTypesForSelect(
      context: ActionContext<CollectionCodeState, any>,
      payload: any
    ) {
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/CollectionCode/GetTypesForSelect", {
        params: payload.data,
      });
      context.state.types = result;
    },
    async export(
      context: ActionContext<CollectionCodeState, any>,
      payload: any
    ) {
      window.open(
        `${
          appconst.remoteServiceBaseUrl
        }export/exportCollectionCodes${abp.utils.buildQueryString(
          Object.keys(payload.data).map((key) => {
            return {
              name: key,
              value: payload.data[key],
            };
          }),
          true
        )}`,
        "_blank"
      );
    },
    async getCollectionCodeBySessionId(
      context: ActionContext<CollectionCodeState, any>,
      payload: any
    ) {
      context.state.loading = true;
      const {
        data: { result },
      } = await Ajax.get(
        `/api/services/app/CollectionCode/${payload.data.id}/session`,
        { params: payload.data }
      );
      context.state.loading = false;
      const page = result as PageResult<any>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async getProductCodesBySessionId(
      context: ActionContext<CollectionCodeState, any>,
      payload: any
    ) {
      const {
        data: { result },
      } = await Ajax.get(
        `/api/services/app/CollectionCode/${payload.data.id}/inAllSession`,
        { params: payload.data }
      );
      return result;
    },
    async exportCollectionCodesBySessionId(
      context: ActionContext<CollectionCodeState, any>,
      payload: any
    ) {
      window.open(
        `${
          appconst.remoteServiceBaseUrl
        }export/exportCollectionCodesBySession${abp.utils.buildQueryString(
          Object.keys(payload.data).map((key) => {
            return {
              name: key,
              value: payload.data[key],
            };
          }),
          true
        )}`,
        "_blank"
      );
    },
  };

  mutations = {
    setCurrentPage(state: CollectionCodeState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: CollectionCodeState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const collectionCodeModule = new CollectionCodeModule();
export default collectionCodeModule;
